/**
 * JsGameConfig — runtime contract stored in `games.game_config`
 * when `engine === "js-runtime"`.
 *
 * The AI generates `code` (a self-contained JS module) that defines
 * `window.LovableGame = { start, destroy }` and posts lifecycle events
 * to the parent via `window.parent.postMessage`.
 */

export type JsGameLibrary = "kaplay";

export interface JsGameMeta {
  title: string;
  description: string;
  grade: string;
  difficulty: "easy" | "medium" | "hard";
  theme?: string;
  estimated_minutes?: number;
}

export interface JsGameConfig {
  engine: "js-runtime";
  library: JsGameLibrary;
  /** Self-contained JS source. No imports, no network, no storage. */
  code: string;
  meta: JsGameMeta;
}

export type LegacyGameConfig = {
  engine?: "scene-spec";
  // ...rest of GameSpec — kept opaque here so we don't import the legacy types.
  [key: string]: unknown;
};

export type AnyGameConfig = JsGameConfig | LegacyGameConfig;

export function isJsRuntimeConfig(cfg: unknown): cfg is JsGameConfig {
  return (
    typeof cfg === "object" &&
    cfg !== null &&
    (cfg as Record<string, unknown>).engine === "js-runtime" &&
    typeof (cfg as Record<string, unknown>).code === "string"
  );
}
